import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import SettingsPage from 'scenes/Settings'
import EditingHistoryPage from 'scenes/EditingHistory'

const RequireAuthRoute = ({
	component: Component,
	location,
	authenticated,
	...rest
}) => (
	<Route
		{...rest}
		render={props => {
			let output = [<Component {...props} key="a" />]

			if (location.hash !== '') {
				if (location.hash.includes('#settings')) {
					let tab = location.hash.replace('#settings-', '')
					tab = tab.replace('#settings', '')

					output = [
						...output,
						<SettingsPage
							key="b"
							tab={tab || 'profile'}
							location={props.location}
						/>,
					]
				}

				if (location.hash === '#editing-history') {
					output = [
						...output,
						<EditingHistoryPage
							key="d"
							location={props.location}
						/>,
					]
				}
			}

			if (authenticated) {
				return output
			}

			// Do not redirect if user follows an invitation
			if (location.pathname === '/invite/') {
				return null
			}

			return (
				<Redirect
					to={{
						pathname: `/login`,
						search:
							location.pathname && location.pathname !== '/'
								? `?d=${location.pathname}${location.hash}`
								: null,
						// state: { from: location },
						// query: { destination: location.pathname + location.hash },
					}}
				/>
			)
		}}
	/>
)

export default RequireAuthRoute
